"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileBrowserCss = void 0;
const utilities_1 = require("./utilities");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
function useFileBrowserCss(hooks) {
    hooks.getTableProps.push(props => utilities_1.AddCssClass(props, "div-table no-select"));
    hooks.getTableBodyProps.push(props => utilities_1.AddCssClass(props, "div-tbody"));
    hooks.getHeaderGroupProps.push(props => utilities_1.AddCssClass(props, "div-tr"));
    hooks.getRowProps.push(props => utilities_1.AddCssClass(props, "div-tr"));
    hooks.getHeaderProps.push(props => utilities_1.AddCssClass(props, "div-th"));
    hooks.getCellProps.push(props => utilities_1.AddCssClass(props, "div-td"));
    hooks.getRowProps.push((props, { row }) => {
        if (utilities_1.IsSelectableRow(row) && row.isSelected) {
            return utilities_1.AddCssClass(props, "row-selected");
        }
        else {
            return props;
        }
    });
    // Add sorting indicator to headers
    // Bit naff, have to mutate columns of final instance to operate on materialized column (with render() method)
    hooks.useFinalInstance.push(instance => {
        instance.visibleColumns.forEach(column => {
            if (utilities_1.IsSortableColumn(column) && column.isSorted) {
                utilities_1.WrapColumnRenderer(column, renderOriginal => react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", null, renderOriginal()),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: column.isSortedDesc ? free_solid_svg_icons_1.faCaretDown : free_solid_svg_icons_1.faCaretUp, style: { marginLeft: "8px" } })), "Header");
            }
        });
    });
}
exports.useFileBrowserCss = useFileBrowserCss;
//# sourceMappingURL=file-browser-css.js.map